import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  requestTemplate: {
    method: 'POST',
    url: `${configs.baseUrl}/api/hook/template/`,
  },
  getTemplate: {
    method: 'GET',
    url: `${configs.baseUrl}/api/templates/by-share-code/{shareCode}`,
    auth: false,
    headers: {
      authorization: null,
    },
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const requestTemplate = (payload) => {
  return resource.requestTemplate(payload)
}

const getTemplate = async (shareCode) => {
  const res = await resource.getTemplate({ shareCode })

  return res && res.body
}

export default {
  initResource,
  requestTemplate,
  getTemplate,
}
